<template>
  <div class="payment-success">
    <div class="payment-success__wrapper">
      <CreditCardLoader :card="getCardInfo" :animation="false" />

      <div
        class="payment-success__content"
        :class="{ 'payment-success__content--visible': isIconResultVisible }"
      >
        <VIconResultMessage
          :type="iconResultMessageData.type"
          :message="iconResultMessageData.message"
          :iconSvgName="iconResultMessageData.iconSvgName"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { CreditCardLoader } from '@/components/payment';
import VIconResultMessage from '@/components/commons/VIconResultMessage';
import { dataLayersMixin } from '@/utils/mixins';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  name: 'PaymentSuccess',
  components: {
    CreditCardLoader,
    VIconResultMessage,
  },
  props: ['card'],
  mixins: [dataLayersMixin],
  data: () => ({
    iconResultMessageData: {
      type: 'success',
      message: ['Pronto, pagamento realizado', 'com sucesso!'],
      iconSvgName: 'creditCard',
    },
    isIconResultVisible: false,
  }),
  computed: {
    ...mapState({
      admission: ({ currentAdmission }) => currentAdmission.data,
      manuallySelectedExams: ({ searchExams }) => searchExams.data.manuallySelectedExams,
    }),
    ...mapGetters({
      isT2FlowAllowed: 'global/isT2FlowAllowed',
      isScheduledAdmission: 'global/isScheduledAdmission',
      isVaccineFlow: 'global/isVaccineFlow',
    }),

    getCardInfo() {
      const { card } = this.$route.params;

      if (card) {
        return card;
      }
      if (this.card) {
        return this.card;
      }

      return '';
    },
  },

  async created() {
    this.showIconResult();
    await this.getAdmissionById();
    await this['global/updateFlowSteps']([8, 2]);

    setTimeout(async () => {
      if (this.isT2FlowAllowed) {
        if (!this.manuallySelectedExams.length) {
          return this.goNextStep('checkin_conclusion_simple');
        }
        return this.goNextStep('end_queue_step');
      }
      return this.goNextStep('end_flow_success');
    }, 2000);
  },
  methods: {
    ...mapActions(['global/updateFlowSteps', 'getAdmissionById']),
    showIconResult() {
      setTimeout(() => {
        this.isIconResultVisible = true;
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-success {
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - 24px);
  justify-content: center;
  position: relative;
  width: 100%;

  &__wrapper {
    height: 510px;
  }

  &__content {
    align-items: center;
    display: flex;
    flex-direction: column;
    opacity: 0;
    padding: 0 10px 0;
    position: relative;
    transform: translateY(-30%);
    transition: opacity 1s ease-in;
    z-index: 0;

    &--visible {
      opacity: 1;
    }
  }
}
</style>
